import React, { ReactNode } from 'react';
import Floater from 'react-floater-fixed';

import { ColorPalette } from 'theme/colors';

import { StyledFloater, TooltipBaloon, Content } from './styles';

export interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  event?: 'click' | 'hover' | undefined;
}

const TooltipContent = ({ content }) => (
  <TooltipBaloon>
    <Content>{content}</Content>
  </TooltipBaloon>
);

const Tooltip = ({ children, content, event }: TooltipProps) => (
  <StyledFloater>
    <Floater
      event={event}
      styles={{ arrow: { color: ColorPalette.HEX.White } }}
      component={() => <TooltipContent content={content} />}
    >
      {children}
    </Floater>
  </StyledFloater>
);

export default Tooltip;
